module.exports = __webpack_public_path__ + "static/bio-siegel-eg-oeko-vo-deutschland-3e91e56161dc8f1bebcf631e882bb65d.png";